const INITIAL_STATE = {
  day_left: null,
  isNotified: false,
};

export const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_USER_EXPIRATION':
      return {
        ...state,
        day_left: action.payload,
      };
    case 'NOTIFY_USER_EXPIRATION':
      return {
        ...state,
        isNotified: action.payload,
      };
    case 'LOGOUT':
      return INITIAL_STATE;

    case 'SET_USER_PROFILE':
      return {
        ...state,
        user_profile: action.payload,
      };
    default:
      return state;
  }
};
